import { Tabs } from 'antd';
import React, { FunctionComponent } from 'react';
import './profile-navigation-tabs.less';

interface DetailsPageNavigationTabsProps {
    activeKey: string;
    onTabClick: (activeKey: string) => void;
}

//Specific component for profile tabs because we need the on click event and therefor need to manage the active tab manually
const ProfileNavigationTabs: FunctionComponent<DetailsPageNavigationTabsProps> = ({
    activeKey,
    onTabClick,
    children,
}) => {
    return (
        <div className="ProfileNavigationTabs">
            <Tabs activeKey={activeKey} onTabClick={onTabClick}>
                {children}
            </Tabs>
        </div>
    );
};

export default ProfileNavigationTabs;
